import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/clockInDevice";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    save:  (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
}
